<not-found-page>

    <div if="{locale}" class="text-center w-full">
        <h1 class="font-bold text-3xl mb-4">404</h1>
        <h2 class="font-bold text-lg mb-2">{locale?.t('notfound_title')}</h2>
        <p>{locale?.t('notfound_message')}</p>
    </div>


    <script>
        export default {
            goHome() {
                this.tools.navigateTo('/')
            },

            goBack() {
                history.back()
            }
        }
    </script>


</not-found-page>